module.exports = __webpack_public_path__ + "img/no-tag3.190b577e.png";